
(function () {
    angular.module('tmx-app').factory('PrivateService', ['$q', 'tmxResource', 'cacheStore',
        function ($q, tmxResource, cacheStore) {

            var Configurations = tmxResource("Configurations");

            Configurations.GetUserCompanyConfigurations = function () {
                var deferred = $q.defer();
                var userCompanyConfigurations = cacheStore.get("Configurations");
                if (!userCompanyConfigurations || userCompanyConfigurations.length == 0) {
                    tmxResource("Configurations").getByAction("GetUserCompanyConfigurations", true).then(function (response) {
                        if (response && response.data) {
                            cacheStore.set("Configurations", angular.copy(response.data));
                            deferred.resolve(response.data);
                        }
                        else {
                            deferred.reject('Unable to get user company configurations');
                        }
                    });
                }
                else {
                    deferred.resolve(userCompanyConfigurations);
                }
                return deferred.promise;
            }
            return Configurations;


        }]);
})();